import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingContent: false,
  },
  actions,
  mutations: {
    'content/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
